export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-IN', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });
};

export const formatTime = (timeStr) => {
  if (!timeStr) return '';
  return timeStr;
};

export const formatDateTime = (dateTimeStr) => {
  if (!dateTimeStr) return '';
  const date = new Date(dateTimeStr);
  return date.toLocaleString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getStatusColor = (status) => {
  const colors = {
    scheduled: 'bg-sky-100 text-sky-700 border-sky-300',
    confirmed: 'bg-teal-100 text-teal-700 border-teal-300',
    checked_in: 'bg-emerald-100 text-emerald-700 border-emerald-300',
    checked_out: 'bg-purple-100 text-purple-700 border-purple-300',
    cancelled: 'bg-red-100 text-red-700 border-red-300',
    forwarded: 'bg-amber-100 text-amber-700 border-amber-300',
    rescheduled: 'bg-indigo-100 text-indigo-700 border-indigo-300',
    no_show: 'bg-rose-100 text-rose-700 border-rose-300',
  };
  return colors[status] || 'bg-gray-100 text-gray-700 border-gray-300';
};

export const getStatusLabel = (status) => {
  const labels = {
    scheduled: 'Scheduled',
    confirmed: 'Confirmed',
    checked_in: 'Checked In',
    checked_out: 'Checked Out',
    cancelled: 'Cancelled',
    forwarded: 'Forwarded',
    rescheduled: 'Rescheduled',
    no_show: 'No Show',
  };
  return labels[status] || status;
};

export const getTagColor = (tag) => {
  const colors = {
    VIP: 'bg-gradient-to-r from-yellow-400 to-amber-500 text-amber-900',
    CM: 'bg-gradient-to-r from-purple-400 to-purple-600 text-white',
    Priority: 'bg-gradient-to-r from-orange-400 to-orange-600 text-white',
  };
  return colors[tag] || 'bg-gray-200 text-gray-700';
};

export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  // Format phone number without country code (country code is handled separately)
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 5)} ${cleaned.slice(5)}`;
  }
  return phone;
};

export const getTimeSlots = () => {
  const slots = [];
  for (let hour = 8; hour <= 20; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const timeStr = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
      slots.push(timeStr);
    }
  }
  return slots;
};

export const getDatesInRange = (start, end) => {
  const dates = [];
  const startDate = new Date(start);
  const endDate = new Date(end);
  
  for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
    dates.push(new Date(d).toISOString().split('T')[0]);
  }
  
  return dates;
};

export const calculateLateness = (scheduledDate, scheduledTime, checkInTime) => {
  if (!scheduledTime || !checkInTime) return 0;
  
  const scheduled = new Date(`${scheduledDate} ${scheduledTime}`);
  const checkIn = new Date(checkInTime);
  
  const diff = (checkIn - scheduled) / 1000 / 60; // minutes
  return Math.max(0, Math.round(diff));
};
